import { useId, useState } from 'react'

/**
 * Dropzone de `3c` e `3f`: arrastar-e-soltar OU clicar, sobre um `<input type=file>`
 * de verdade — é ele que dá teclado, leitor de tela e o seletor nativo de graça.
 */
export function ZonaDeArquivo({
  titulo,
  descricao,
  icone,
  multiplo = false,
  rotulo,
  desabilitada = false,
  aoEscolher,
}: {
  titulo: string
  descricao: string
  icone: string
  multiplo?: boolean
  /** Nome acessível do input. */
  rotulo: string
  desabilitada?: boolean
  aoEscolher: (arquivos: File[]) => void
}) {
  const id = useId()
  const [sobre, setSobre] = useState(false)

  return (
    <label
      htmlFor={id}
      onDragOver={(e) => {
        e.preventDefault()
        if (!desabilitada) setSobre(true)
      }}
      onDragLeave={() => setSobre(false)}
      onDrop={(e) => {
        e.preventDefault()
        setSobre(false)
        if (!desabilitada) aoEscolher(Array.from(e.dataTransfer.files))
      }}
      className={`rounded-card flex flex-col items-center gap-1 border border-dashed p-6 text-center duration-fast ${
        sobre ? 'border-iox-navy bg-navy-100' : 'border-navy-200 bg-navy-50'
      } ${desabilitada ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
    >
      <i className={`ph ph-${icone} text-iox-navy text-2xl`} aria-hidden="true" />
      <span className="type-label text-iox-navy">{titulo}</span>
      <span className="type-sm text-text-muted">{descricao}</span>
      <input
        id={id}
        type="file"
        aria-label={rotulo}
        className="sr-only"
        multiple={multiplo}
        disabled={desabilitada}
        accept=".pdf,.docx,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        onChange={(e) => {
          aoEscolher(Array.from(e.target.files ?? []))
          // Permite escolher o mesmo arquivo de novo depois de removê-lo.
          e.target.value = ''
        }}
      />
    </label>
  )
}
